<template>
    <v-footer :app="true" elevation="5">
        <v-row
            justify="center"
            no-gutters
        >
            <v-btn
                class="mx-2"
                rounded="xl"
                variant="text"
                target="_blank"
                :href="privacyLink"
                prepend-icon="mdi-open-in-new"
            >
                <p class="text-decoration-underline">
                    Datenschutz
                </p>
            </v-btn>
            <v-btn
                class="mx-2"
                rounded="xl"
                variant="text"
                target="_blank"
                :href="imprintLink"
                prepend-icon="mdi-open-in-new"
            >
                <p class="text-decoration-underline">
                    Impressum
                </p>
            </v-btn>
        </v-row>
    </v-footer>
</template>

<script setup>
import { computed, inject } from 'vue'
import INJECTION_KEYS from '@injectionKeys'

/** @type {GlobalState} */
const globalState = inject(INJECTION_KEYS.GLOBALSTATE)

const privacyLink = computed(() => {
    return globalState.systemConfig.urlPrivacy
})
const imprintLink = computed(() => {
    return globalState.systemConfig.urlImprint
})
</script>
